export class SongsExpander {
  constructor(songsJson) {
    this.songsJson = songsJson;
  }

  expand() {
    this.songsJson.songs.forEach(song => {
      // Create a map of labeled elements (sections with keys)
      const sectionMap = new Map();
      song.sections.forEach(section => {
        if (section.key) {
          sectionMap.set(section.key, section.content);
        }
      });

      // Replace references [<key>] with the corresponding section content
      song.sections.forEach(section => {
        section.content = section.content.flatMap(lineGroup => {
          const containsReference = lineGroup.some(line => line.type === 'text' && /\[([^\]]+)\]/.test(line.content));
          if (containsReference) {
            const match = lineGroup.find(line => line.type === 'text' && /\[([^\]]+)\]/.test(line.content)).content.match(/\[([^\]]+)\]/);
            const key = match[1]; // Extract key from [<key>]
            if (sectionMap.has(key)) {
              return sectionMap.get(key); // Replace with the referenced section content
            }
          }
          return [lineGroup]; // Keep the original lineGroup if no reference is found
        });
      });
    });
    return this.songsJson;
  }
}
